// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CascadeDirection,
  CascadeTrigger,
  CascadeEffect,
  RgbaColor,
} from "./types";


export default __t.row({
  ruleId: __t.u64().primaryKey().name("rule_id"),
  relationshipName: __t.string().name("relationship_name"),
  triggerDtmi: __t.option(__t.string()).name("trigger_dtmi"),
  get direction() {
    return CascadeDirection;
  },
  get triggers() {
    return __t.array(CascadeTrigger);
  },
  get effect() {
    return CascadeEffect;
  },
  opacity: __t.f32(),
  useOverrideOpacity: __t.bool().name("use_override_opacity"),
  get overrideColor() {
    return RgbaColor.name("override_color");
  },
  useOverrideColor: __t.bool().name("use_override_color"),
  maxDepth: __t.i32().name("max_depth"),
});
